module.exports = __webpack_public_path__ + "img/unknown_Persons.9cfb0f7e.svg";